// laba rugi
export const LABA_KOTOR = { url: "laba-kotor", title: "Laba Kotor" };
export const LABA_USAHA = { url: "laba-usaha", title: "Laba Usaha" };
export const EBITDA = { url: "ebitda", title: "EBITDA" };
export const EBIT = { url: "ebit", title: "EBIT" };
export const PBT = { url: "pbt", title: "PBT" };
// export const LABA_BERSIH = { url: "laba-bersih", title: "Laba Bersih" };


// neraca
export const LIABILITY = { url: "liability", title: "Liability" };
export const EQUITY = { url: "equity", title: "Equity" };
export const ASET_LANCAR = { url: "asset-lancar", title: "Aset Lancar" };
export const ASET_TIDAK_LANCAR = { url: "asset-tidak-lancar", title: "Aset Tidak Lancar" };
export const ASET_TETAP = { url: "asset-tetap", title: "Aset Tetap" };


// export const ASSET = { url: "asset", title: "Asset" };
export const ASSET = { url: "asset-all", title: "Asset" };
export const LIABILITY_M = { url: "liability-m", title: "Liabilitas" };
export const LABA_RUGI = { url: "laba-rugi", title: "Laba Rugi" };
export const EQUITY_M = { url: "equity-m", title: "Ekuitas" };
export const EBITDA_M = { url: "ebitda-m", title: "Ebitda" };
export const LABA_BERSIH_M = { url: "lr-laba-bersih-komprehensif-tahun-berjalan", title: "Laba Bersih" };
export const PENDAPATAN_USAHA = { url: "lr-pendapatan-usaha", title: "Pendapatan Usaha" };

// PMD dan Deviden
export const PENYERTAAN_MODAL = { url: "pmd", title: "Penyertaan Modal" };
export const DEVIDEN = { url: "deviden", title: "Deviden" };

// Table Legend Chart Dashboard
export const CHART_DASHBOARD = { url: "chart-legend" };
// export const CHART_DASHBOARD_ASSET = { url: "chart-legend-asset" };
export const CHART_DASHBOARD_ASSET = { url: "latest-chart-legend-asset" };